import {ValueObject} from '@s-ui/domain'

import {FilterAggregationsSearchValueObject} from './FilterAggregationsSearchValueObject.js'

export class FilterAggregationSearchValueObject extends ValueObject {
  #id
  #name
  #nestedAggregations
  #totalResults
  #value

  constructor({id, name, nestedAggregations, totalResults, value}) {
    super()
    this.#id = id
    this.#name = name
    this.#nestedAggregations = nestedAggregations
    this.#totalResults = totalResults
    this.#value = value
  }

  static createFromPrimitives({id, name, nestedAggregations, totalResults, value}) {
    const nestedAggregationsValueObject = nestedAggregations
      ? FilterAggregationsSearchValueObject.createFromPrimitives({
          items: nestedAggregations?.items || [],
          name: nestedAggregations?.name
        })
      : null

    return new FilterAggregationSearchValueObject({
      id,
      name,
      nestedAggregations: nestedAggregationsValueObject,
      totalResults,
      value
    })
  }

  get id() {
    return this.#id
  }

  get name() {
    return this.#name
  }

  get nestedAggregations() {
    return this.#nestedAggregations?.getValue()
  }

  get totalResults() {
    return this.#totalResults
  }

  get value() {
    return this.#value
  }

  getValue() {
    return {
      id: this.id,
      name: this.name,
      nestedAggregations: this.nestedAggregations,
      totalResults: this.totalResults,
      value: this.value
    }
  }
}
